module.exports = __webpack_public_path__ + "static/img/authorize-bg.becec19f.png";